import { domainColor } from '../../theme/tokens';
import type { GraphNode } from '../../api/knowledge';

export interface DomainInfo {
  name: string;
  color: string;
  count: number;
}

export function deriveDomainInfo(nodes: GraphNode[]): Map<string, DomainInfo> {
  const names: string[] = [];
  const counts = new Map<string, number>();

  for (const node of nodes) {
    const name = node.domain || 'unknown';
    if (!counts.has(name)) names.push(name);
    counts.set(name, (counts.get(name) ?? 0) + 1);
  }

  names.sort();
  const info = new Map<string, DomainInfo>();
  names.forEach((name, idx) => {
    info.set(name, {
      name,
      color: name === 'emergent' ? 'rgba(255,255,255,0.55)' : domainColor(idx),
      count: counts.get(name) ?? 0,
    });
  });
  return info;
}

const QUALITY_MIN = 0.2;
const QUALITY_MAX = 0.95;
const NODE_MIN = 16;
const NODE_MAX = 44;

export function nodeSizeForQuality(quality: number): number {
  const q = Math.max(QUALITY_MIN, Math.min(QUALITY_MAX, quality));
  const t = (q - QUALITY_MIN) / (QUALITY_MAX - QUALITY_MIN);
  return NODE_MIN + t * (NODE_MAX - NODE_MIN);
}
